/***************************************************************************************
 * FileName      : Main.js
 * Description   : 소곤핏 메인페이지
 * Company       : (주)엘리그
 * Author        : 박권희
 * Created Date  : 2024.03.19
 * Modifide Date : 2024.04.04 : CHM : 모바일 앱 사용 시 앱 다운로드 배너 제거
 *               : 2024.06.14 : CHM : 메인 콘텐츠 소곤톡 미리보기 추가
 * 				 : 2024.08.23 : PKH : 디자인 수정사항 반영  
 * Reference     :
 ***************************************************************************************/
import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MagazineItem from "./Main/MagazineItem";
import LatestItem from "./Main/LatestItem";
import ProductItem from "./Main/ProductItem";
import MagazineMain from "./Main/MagazineMain";

import {
	getMainContents,
	getProductContents,
	getPostContents,
} from "../../api/services/mainApi";

import Gnb from "../../Gnb";
import { Helmet } from "react-helmet-async";


import Footer from "../../Footer";

import Songontalk from "./Main/SogontalkItem";


function Main() {
	const navigate = useNavigate();
	const [content, setContent] = useState([]);
	const [productContent, setProductContent] = useState([]);
	const [postNewContent, setPostNewContent] = useState([]);
	const [postHotContent, setPostHotContent] = useState([]);
	const [currentContentIndex, setCurrentContentIndex] = useState(0);

	const [mainLoading, setMainLoading] = useState(false);



	// 접근 디바이스 모바일 앱인지 확인
	const [isMobileApp, setIsMobileApp] = useState(false);
	useEffect(() => {
		setIsMobileApp(/appUser/i.test(navigator.userAgent));
	}, [isMobileApp]);
	console.log(navigator.userAgent);

	useEffect(() => {
		setMainLoading(true);

		getMainContents()
			.then((res) => {
				setContent(res.data.data);
				setMainLoading(false);
			})
			.catch((error) => {
				console.log(error?.response?.data?.data);
			});

		getProductContents()
			.then((res) => {
				setProductContent(res?.data?.data);
			})
			.catch((error) => {
				console.log(error?.response?.data?.data);
			});

		getPostContents("new")
			.then((res) => setPostNewContent(res?.data?.data))
			.catch((error) => {
				console.log(error?.response?.data?.data);
			});

		getPostContents("popular")
			.then((res) => setPostHotContent(res?.data?.data))
			.catch((error) => {
				console.log(error?.response?.data?.data);
			});
	}, []);


	return (
		<>
			<Helmet>
				<title>소곤핏 Sogonfit - Main</title>
			</Helmet>
			<div className="main">
				{!isMobileApp && ( // 모바일 앱 사용 시 앱 다운로드 배너 제거
					<button className="app-banner">
						<div>
							<img
								src={
									process.env.PUBLIC_URL + "favicon-96x96.png"
								}
								alt=""
							/>
							<span className="app-banner-title">
								소곤핏 - 우리만의 언더웨어 쇼핑 일기
							</span>
						</div>
					</button>
				)}

				{/* 메인 배너 */}
				<section className="banner-content">
					<div className="nopadding">
						{/* <video
							poster={
								process.env.PUBLIC_URL +
								"img/showcase_preview.png"
							}
							autoPlay
							loop
							muted
							playsInline
							className="w-100"
							onClick={() => {
								navigate("/bbti");
								window.hackleClient.track({
									key: "clicked_banner",
									properties: {
										배너타입: "영상배너", // 영상배너, 이미지배너
									},
								});
							}}
						>
							<source
								src={
									process.env.PUBLIC_URL +
									"../img/showcase_preview.mp4"
								}
								type="video/mp4"
							/>
						</video> */}

						{
							content[0]?.contents[0] &&
							<MagazineMain
								content={content[0]?.contents[0]}
								npwPage={"메인페이지"}
							/>
						}

					</div>
				</section>

				{/* 소곤핏 메뉴 리스트 */}
				{/* 
				<section className="main-category">
					<div className="inner">
						<Row>
							<Col className="text-center">
								<Link className="m-category-item"
									to="/post"
									onClick={() => {
										window.hackleClient.track({
											key: "clicked_category",
											properties: {
												카테고리명: "소곤톡",
											},
										});
									}}
								>
									<TalkIcon className="m-category-icon"/>
									<br/>
									<span style={{"color": "#ff9680"}}>소곤톡</span>
								</Link>
							</Col>
							<Col className="text-center">
								<Link className="m-category-item"
									to="/magazine"
									onClick={() => {
										window.hackleClient.track({
											key: "clicked_category",
											properties: {
												카테고리명: "소곤로그",
											},
										});
									}}
								>
									<LogIcon className="m-category-icon"/>
									<br/>
									<span style={{"color": "#ff9680"}}>소곤로그</span>
								</Link>
							</Col>
							<Col className="text-center">
								<Link className="m-category-item"
									to="/product"
									onClick={() => {
										window.hackleClient.track({
											key: "clicked_category",
											properties: {
												카테고리명: "SHOP",
											},
										});
									}}
								>
									<ShoppingIcon className="m-category-icon"/>
									<br/>
									<span style={{"color": "#ff9680"}}>SHOP</span>
								</Link>
							</Col>
							<Col className="text-center">
								<Link className="m-category-item"
									to="/bbti"
									onClick={() => {
										window.hackleClient.track({
											key: "clicked_category",
											properties: {
												카테고리명: "분석",
											},
										});
									}}
								>
									<AnalysisIcon className="m-category-icon"/>
									<br/>
									<span style={{"color": "#ff9680"}}>분석</span>
								</Link>
							</Col>
							<Col className="text-center">
								<Link className="m-category-item"
									onClick={() => {
										window.hackleClient.track({
											key: "clicked_category",
											properties: {
												카테고리명: "AboutUs",
											},
										});
										window.open(
											"https://daffy-rabbit-ea1.notion.site/3bfac3c4e34943a69b4df09b856af328#2a23e3eefd674108a940fc47c00a776e"
										);
									}}
								>
									<AboutusIcon className="m-category-icon"/>
									<br/>
									<span style={{"color": "#ff9680"}}>AboutUs</span>
								</Link>
							</Col>
							
						</Row>
					</div>
				</section>
				*/}

				{/* 소곤톡 콘텐츠 미리보기 */}
				<section className="sogontalk">
					<div className="inner">
						<div className="title">
							<p>소곤톡</p>
							<div className="tab-btns">
							<span 
								className={`tab-btn ${currentContentIndex === 0 ? 'select' : ''}`} 
								onClick={() => setCurrentContentIndex(0)}
								>
							new
							</span>	
							<span 
								className={`tab-btn ${currentContentIndex === 1 ? 'select' : ''}`} 
								onClick={() => setCurrentContentIndex(1)}
								>
								hot
							</span>			
							</div>
						</div>	
						<div className="contents">
							{(currentContentIndex === 0
								? postNewContent
								: postHotContent
							)?.map((item, index) => (
								<Songontalk item={item} />
							))}
						
						</div>
					</div>
				</section>

				{/* 메인 콘텐츠 */}
				<section className="main-content">
					<div className="inner">
						{content?.map((item, index) => (
							<div key={index}>
								<div className="title-wrap">
									<p className="main-title">{item?.title}</p>
									<span
										className="morebtn"
										onClick={() =>
											navigate(
												`/magazine?type=${item?.type}`
											)
										}
									>
										more &gt;
									</span>
								</div>

								{item.main_content_exist && (
									<MagazineMain
										content={item?.main_content}
										npwPage={"메인페이지"}
									/>
								)}

								{item.x_layout === 1 && (
									<div className="latestContent-wrap">
										{item.contents.map((contentItem) => (
											<LatestItem
												key={contentItem.id}
												content={contentItem}
												isLoading={mainLoading}
												nowPage={"메인페이지"}
											/>
										))}
									</div>
								)}

								{item.x_layout === 2 && (
									<div className="magazine-wrap">
										{item.contents.map((contentItem) => (
											<MagazineItem
												key={contentItem.id}
												content={contentItem}
											/>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				</section>

				{/* 상품 추천 */}
				<section className="recommended-content">
					<div className="inner">
						{/* <div className="title-wrap">
							<p className="main-title">이런 상품 어때요?</p>
							<span
								className="morebtn"
								onClick={() => navigate("/magazine")}
							>
								more &gt;
							</span>
						</div> */}

						{productContent?.map((item, index) => (
							<React.Fragment key={index}>
								<div className="title-wrap">
									<p className="main-title">{item.title}</p>
									<span
										className="morebtn"
										onClick={() => navigate("/product")}
									>
										more &gt;
									</span>
								</div>
								<div className="product-wrap">
									{item.contents.map(
										(content, contentIndex) => (
											<ProductItem
												item={content}
												key={contentIndex}
												clickArea={"메인페이지"}
												onClick={() => {
													window.hackleClient.track({
														key: "clicked_product",
														properties: {
															클릭위치:
																"메인페이지",
															상품정보: `${content?.id} - ${content?.name}`, // 상품ID-상품명
														},
													});
												}}
											/>
										)
									)}
								</div>
							</React.Fragment>
						))}
					</div>
				</section>
				<Footer />
				<Gnb />
			</div>
		</>
	);
}

export default Main;
